import {Box, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuFileBadge} from 'react-icons/lu'
export function EmptyProtocolCard() {
  const {t} = useTranslate()
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      borderRadius={'md'}
      border={'solid'}
      bg={'bg.subtle'}
      borderWidth={'1px'}
      borderColor={'gray.focusRing'}
      minWidth="18rem"
      maxWidth="28rem"
      height="6.75rem"
      gap={'2'}
      p="4"
      justifyContent={'space-between'}
    >
      <Box>
        <LuFileBadge size="32" color="gray" />
      </Box>
      <Box>
        <Text fontSize={'sm'} color="fg.muted">
          {t('no_associated_protocol')}
        </Text>
      </Box>
    </Box>
  )
}
